<!-- Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved. -->
<ng-container *ngIf="!hasError">

  <div *ngIf="loading" class="viewport-spacer"></div>

  <div *ngIf="loading" class="local-overlay" role="status" aria-live="polite" aria-busy="true">
    <mat-spinner aria-hidden="true"></mat-spinner>
    <span class="sr-only">Loading</span>
  </div>

  <div class="recCnt">
    <div class="sample">
      <span class="kind">Variants:</span> 
      <span class="variants">{{ nf.format(Variants) }}</span> 
      <span class="flex-spacer"></span>
      <app-input 
        [inputStyle]="'search-gene-name-field'" 
        [placeholder]="placeHolderText" 
        [formCntlName]="searchCtrl" 
        [inputType]="textInputType" 
        [suffixInputIcon]="iconName"
      ></app-input>
    </div>
  </div>

  <div class="table-wrap">
    <div class="h-wrap">
      <table mat-table 
        [dataSource]="dataSource" 
        matSort 
        [matSortActive]="'chr'" 
        [matSortDirection]="'asc'" 
        matSortDisableClear="true"
      >

        <!-- gene_id -->
        <ng-container matColumnDef="gene_id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="gene_id">ID</th>
          <td mat-cell *matCellDef="let r">{{ r.gene_id }}</td>
        </ng-container>

        <!-- chr -->
        <ng-container matColumnDef="chr">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="chr">Chr</th>
          <td mat-cell *matCellDef="let r">{{ r.chr }}</td>
        </ng-container>

        <!-- pn (strand) -->
        <ng-container matColumnDef="pn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="pn">PN</th>
          <td mat-cell *matCellDef="let r">{{ r.pn }}</td>
        </ng-container>

        <!-- start -->         
        <ng-container matColumnDef="start">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="start">Start</th>
          <td mat-cell *matCellDef="let r">{{ nf.format(r.start) }}</td>
        </ng-container>

        <!-- end -->
        <ng-container matColumnDef="end">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="end"> End</th>
          <td mat-cell *matCellDef="let r">{{ nf.format(r.end) }}</td>
        </ng-container>

        <!-- gene_type -->
        <ng-container matColumnDef="gene_type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="gene_type">Gene Type</th>
          <td mat-cell *matCellDef="let r">{{ r.gene_type }}</td>
        </ng-container>

        <!-- gene_name -->
        <ng-container matColumnDef="gene_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="gene_name">Gene Name</th>
          <td mat-cell *matCellDef="let r">
            <a href="javascript:void(0)" (click)="openAlignmentViewer(r.start, r.end, r.chr)" class="gene_name">
              {{ r.gene_name }}
            </a>
          </td>
        </ng-container>

        <!-- svs -->
        <ng-container matColumnDef="svs">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="svs">Svs</th>
          <td mat-cell *matCellDef="let r" class="svs">
            <ng-container *ngFor="let svId of r.svs; let i = index; trackBy: trackByNumber">
              <a href="javascript:void(0)" (click)="openAlignmentViewer(r.start, r.end, r.chr, svId)" class="svId">
                {{ svId }}
              </a>
            </ng-container>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <tr class="mat-mdc-row no-data-row" *matNoDataRow>
          <td class="mat-mdc-cell no-data-cell" [attr.colspan]="displayedColumns.length">
            No Data Found
          </td>
        </tr>
      </table>
    </div>
  </div>
</ng-container>

<mat-paginator
  [class.hidden]="hasError"
  [pageSize]="10"
  [pageSizeOptions]="[10, 25, 50, 100]"
  [showFirstLastButtons]="true">
</mat-paginator>
